module.exports = __webpack_public_path__ + "img/cases-brand-19-cover.ef97ade9.png";